export default "https://cdn-static.gokick.com/assets/d7539373fb86e46f3eed15b4b495ca9c5158faa3/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";